import React, { useState } from 'react';
import { Card, Col, Badge } from 'react-bootstrap';
import { Tool } from '../../interfaces';
import { faArrowRight, faImage, faLock, faPen, faUnlock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Paragraph } from '../../components/common/SimpleControls/Paragraph';
import { useTranslation } from 'react-i18next';
import ToolsEditModal from './ToolsEditModal';
import './Tools.css';

const ToolsControl: React.FC<Tool> = ({ id, url, image, name, description, isIntern }) => {
  const { t } = useTranslation();
  const [showEditModal, setShowEditModal] = useState(false);
  const currentTool: Tool = { id, url, image, name, description, isIntern };

  return (

    <Col lg={4} md={7} xs={12} className="mb-4">
      <Card className="h-100 rounded-4 tool-card border-primary">
        <Card.Body className="d-flex flex-column p-4">

          <div className="d-flex justify-content-between align-items-start mb-3">
            {image ? (
              <div className="me-3">
                <img src={image} alt={`${name} logo`} className="me-3" height="28" />
              </div>
            ) : (
              <Badge className="rounded-5 p-2  text-white bg-primary fs-6" >
                <FontAwesomeIcon icon={faImage} />
              </Badge>
            )}
            <Card.Title className="mb-0 fw-bold fs-4 text-secondary">{name}</Card.Title>
            <Badge className={`p-2 rounded-5 fs-6 ${isIntern ? 'bg-danger' : 'bg-success'}`}>
              <FontAwesomeIcon icon={isIntern ? faLock : faUnlock} />
            </Badge>
          </div>
          <Paragraph>{t(description)}</Paragraph>
          <Card.Link className="text-decoration-none" href={url} target="_blank" rel="noopener noreferrer">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                {!image && (
                  <Badge className="badge-tools p-2 rounded-5 text-white bg-primary fs-6" onClick={(e) => { e.preventDefault(); setShowEditModal(true); }}>
                    <FontAwesomeIcon icon={faPen} />
                  </Badge>
                )}
              </div>
              <FontAwesomeIcon icon={faArrowRight} className="arrowIcon" />
            </div>
          </Card.Link>
        </Card.Body>
      </Card>
      <ToolsEditModal show={showEditModal} handleClose={() => setShowEditModal(false)} tool={currentTool} />
    </Col>
  );
};

export default ToolsControl;
